import { AppointmentParticipantType } from '@generated/gql/graphql';

export const SHARE_URL = 'uw.link/meet';

export enum AppointmentSnackbar {
  CUSTOMER_LEFT = 'CUSTOMER_LEFT',
  CUSTOMER_JOINED = 'CUSTOMER_JOINED',
}

type ColorScheme =
  | 'mobile'
  | 'pig'
  | 'insurance'
  | 'energy'
  | 'info'
  | 'positive'
  | 'danger'
  | 'warning'
  | 'functional'
  | 'broadband'
  | 'cashback'
  | 'highlight'
  | undefined;

type ParticipantColorScheme = Record<AppointmentParticipantType, ColorScheme>;

export const ParticipantColorScheme: ParticipantColorScheme = {
  [AppointmentParticipantType.Partner]: 'pig',
  [AppointmentParticipantType.Customer]: 'insurance',
  [AppointmentParticipantType.SupportingPartner]: 'energy',
};

export const UserTypeDisplayMap: Record<AppointmentParticipantType, string> = {
  [AppointmentParticipantType.Partner]: 'Lead Partner',
  [AppointmentParticipantType.Customer]: 'Customer',
  [AppointmentParticipantType.SupportingPartner]: 'Supporting Partner',
};
